import { render, staticRenderFns } from "./TournamentEditGrid.vue?vue&type=template&id=551b4216&scoped=true"
import script from "./TournamentEditGrid.vue?vue&type=script&lang=js"
export * from "./TournamentEditGrid.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditGrid.vue?vue&type=style&index=0&id=551b4216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b4216",
  null
  
)

export default component.exports